import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // {
    //   path: '/index',
    //   name: 'index',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/index.vue')
    // },
    {
      path: '/index1',
      name: 'index1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/index1.vue'),
      children: [
        {
          path: '/',
          name: 'shouye',
          component: () => import(/* webpackChunkName: "about" */ './views/shouye.vue'),
          meta:{
            name1:"首页"
          },
        },
        {
          path: '/notebook',
          name: 'notebook',
          component: () => import(/* webpackChunkName: "about" */ './views/notebook.vue'),
          meta:{
            name:"记事本管理",
            name1:"我的办公",
            name2:"/"
          },
        },
        {
          path: '/news',
          name: 'news',
          component: () => import(/* webpackChunkName: "about" */ './views/new.vue'),
          meta:{
            name:"新闻通知管理",
            name1:"系统管理",
            name2:"/"
          },
        },
        {
          path: '/address_list',
          name: 'address_list',
          component: () => import(/* webpackChunkName: "about" */ './views/address.vue'),
          meta:{
            name:"通讯录管理",
            name1:"我的办公",
            name2:"/"
          },
        },
        {
          path: '/address_ype',
          name: 'address_ype',
          component: () => import(/* webpackChunkName: "about" */ './views/address_ype.vue'),
          meta:{
            name:"通讯录类别",
            name1:"我的办公",
            name2:"/"
          },
        },
        {
          path: '/expenseAccount',
          name: 'expenseAccount',
          component: () => import(/* webpackChunkName: "about" */ './views/expenseAccount.vue'),
          meta:{
            name:"报销申请单",
            name1:"我的办公",
            name2:"/"
          },
        },
        {
          path: '/whiteboard',
          name: 'whiteboard',
          component: () => import(/* webpackChunkName: "about" */ './views/whiteboard.vue'),
          meta:{
            name:"小白板",
            name1:"我的办公",
            name2:"/"
          },
        },
        {
          path: '/notebook_type',
          name: 'notebook_type',
          component: () => import(/* webpackChunkName: "about" */ './views/notebook_type.vue'),
          meta:{
            name:"记事本类别管理",
            name1:"我的办公",
            name2:"/"
          },
        },
        {
          path: '/customer',
          name: 'customer',
          component: () => import(/* webpackChunkName: "about" */ './views/customer.vue'),
          meta:{
            name:"客户信息管理",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/customer_ype',
          name: 'customer_ype',
          component: () => import(/* webpackChunkName: "about" */ './views/customer_ype.vue'),
          meta:{
            name:"客户组别",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/inventory',
          name: 'inventory',
          component: () => import(/* webpackChunkName: "about" */ './views/inventory.vue'),
          meta:{
            name:"采购管理",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/product',
          name: 'product',
          component: () => import(/* webpackChunkName: "about" */ './views/product.vue'),
          meta:{
            name:"存货",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/provide',
          name: '/provide',
          component: () => import(/* webpackChunkName: "about" */ './views/provide.vue'),
          meta:{
            name:"供应商管理",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/provide_type',
          name: '/provide_type',
          component: () => import(/* webpackChunkName: "about" */ './views/provide_type.vue'),
          meta:{
            name:"供应商类别管理",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/xiaoshouguanli',
          name: '/xiaoshouguanli',
          component: () => import(/* webpackChunkName: "about" */ './views/xiaoshouguanli.vue'),
          meta:{
            name:"销售管理",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/shangpingmingxi',
          name: '/shangpingmingxi',
          component: () => import(/* webpackChunkName: "about" */ './views/shangpingmingxi.vue'),
          meta:{
            name:"商品明细",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/xiaoshou',
          name: '/xiaoshou',
          component: () => import(/* webpackChunkName: "about" */ './views/xiaoshou.vue'),
          meta:{
            name:"销售单",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/salesRefunds',
          name: '/salesRefunds',
          component: () => import(/* webpackChunkName: "about" */ './views/salesRefunds.vue'),
          meta:{
            name:"销售退货",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/purchaseRefunds',
          name: 'purchaseRefunds',
          component: () => import(/* webpackChunkName: "about" */ './views/purchaseRefunds.vue'),
          meta:{
            name:"采购退货管理",
            name1:"进销存管理",
            name2:"/"
          },
        },
        {
          path: '/inputInvoice',
          name: 'inputInvoice',
          component: () => import(/* webpackChunkName: "about" */ './views/inputInvoice.vue'),
          meta:{
            name:"进项发票管理",
            name1:"财务管理",
            name2:"/"
          },
        },
        {
          path: '/xiaoxiang',
          name: 'xiaoxiang',
          component: () => import(/* webpackChunkName: "about" */ './views/xiaoxiang.vue'),
          meta:{
            name:"销项发票管理",
            name1:"财务管理",
            name2:"/"
          },
        },
        {
          path: '/expenseAccount_ype',
          name: 'expenseAccount_ype',
          component: () => import(/* webpackChunkName: "about" */ './views/expenseAccount_ype.vue'),
          meta:{
            name:"报销审批管理",
            name1:"财务管理",
            name2:"/"
          },
        },
        {
          path: '/supplierSettlement',
          name: 'supplierSettlement',
          component: () => import(/* webpackChunkName: "about" */ './views/supplierSettlement.vue'),
          meta:{
            name:"供应商结算管理",
            name1:"财务管理",
            name2:"/"
          },
        },	
        {
          path: '/salesOrderSettlement',
          name: 'salesOrderSettlement',
          component: () => import(/* webpackChunkName: "about" */ './views/salesOrderSettlement.vue'),
          meta:{
            name:"销售订单结算管理",
            name1:"财务管理",
            name2:"/"
          },
        },	
        {
          path: '/jingdu',
          name: 'jingdu',
          component: () => import(/* webpackChunkName: "about" */ './views/jingdu.vue'),
          meta:{
            name:"进度管理",
            name1:"项目管理",
            name2:"/"
          },
        },	
        {
          path: '/fy',
          name: 'fy',
          component: () => import(/* webpackChunkName: "about" */ './views/fy.vue'),
          meta:{
            name:"费用管理",
            name1:"项目管理",
            name2:"/"
          },
        },	
        {
          path: '/cl',
          name: 'cl',
          component: () => import(/* webpackChunkName: "about" */ './views/cl.vue'),
          meta:{
            name:"材料管理",
            name1:"项目管理",
            name2:"/"
          },
        },	
        {
          path: '/role',
          name: 'role',
          component: () => import(/* webpackChunkName: "about" */ './views/role .vue'),
          meta:{
            name:"角色管理",
            name1:"系统管理",
            name2:"/"
          },
        },
        {
          path: '/department',
          name: 'department',
          component: () => import(/* webpackChunkName: "about" */ './views/department.vue'),
          meta:{
            name:"部门管理",
            name1:"系统管理",
            name2:"/"
          },
        },
        {
          path: '/userList',
          name: 'userList',
          component: () => import(/* webpackChunkName: "about" */ './views/userList.vue'),
          meta:{
            name:"用户管理",
            name1:"系统管理",
            name2:"/"
          },
        },
        {
          path: '/menuList',
          name: 'menuList',
          component: () => import(/* webpackChunkName: "about" */ './views/menuList.vue'),
          meta:{
            name:"菜单管理",
            name1:"系统管理",
            name2:"/"
          },
        },
        {
          path: '/employee',
          name: 'employee',
          component: () => import(/* webpackChunkName: "about" */ './views/employee.vue'),
          meta:{
            name:"优秀员工管理",
            name1:"系统管理",
            name2:"/"
          },
        },
        {
          path: '/dictionary_value',
          name: 'dictionary_value',
          component: () => import(/* webpackChunkName: "about" */ './views/dictionary_value.vue'),
          meta:{
            name:"字典值管理",
            name1:"系统管理",
            name2:"/"
          },
        },
        {
          path: '/dictionaries',
          name: 'dictionaries',
          component: () => import(/* webpackChunkName: "about" */ './views/dictionaries.vue'),
          meta:{
            name:"字典类型",
            name1:"系统管理",
            name2:"/"
          },
        },
        {
          path: '/xiugaimima',
          name: 'xiugaimima',
          component: () => import(/* webpackChunkName: "about" */ './views/xiugaimima.vue'),
          meta:{
            name:"修改密码",
            name1:"用户信息",
            name2:"/"
          },
        },     
        
        
        {
          path: '/review',
          name: 'review',
          meta:{
            name:"审批流程",
            name1:"系统管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/review.vue')
        },
        {
          path: '/review_type',
          name: 'review_type',
          meta:{
            name:"审批流程节点管理",
            name1:"系统管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/review_type.vue')
        },
        {
          path: '/rizhi',
          name: 'rizhi',
          meta:{
            name:"日志",
            name1:"系统管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/rizhi.vue')
        },
        {
          path: '/rent',
          name: 'rent',
          meta:{
            name:"设备租赁管理",
            name1:"事务管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/rent.vue')
        },
        {
          path: '/rent_type',
          name: 'rent_type',
          meta:{
            name:"设备租赁单据",
            name1:"事务管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/rent_type.vue')
        },
        {
          path: '/kuaidi',
          name: 'kuaidi',
          meta:{
            name:"快递收发管理",
            name1:"事务管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/kuaidi.vue')
        },
        {
          path: '/wodezhishiku',
          name: 'wodezhishiku',
          meta:{
            name:"我的知识库",
            name1:"知识库管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/wodezhishiku.vue')
        },
        {
          path: '/zhishikutype',
          name: 'zhishikutype',
          meta:{
            name:"知识库类别",
            name1:"知识库管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/zhishikutype.vue')
        },
        {
          path: '/zhishiku',
          name: 'zhishiku',
          meta:{
            name:"知识库列表",
            name1:"知识库管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/zhishiku.vue')
        },
        {
          path: '/zhishikupeizhi',
          name: 'zhishikupeizhi',
          meta:{
            name:"知识库配置",
            name1:"知识库管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/zhishikupeizhi.vue')
        },
        {
          path: '/xiangmujichu',
          name: 'xiangmujichu',
          meta:{
            name:"项目基础信息",
            name1:"项目管理",
            name2:"/"
          },
          component: () => import(/* webpackChunkName: "about" */ './views/xiangmujichu.vue')
        },
        {

          path: '/xiaoshou',
          name: 'xiaoshou',
          component: () => import(/* webpackChunkName: "about" */ './views/xiaoshou.vue')
        },
      ]
    },
    {
      path: '/side',
      name: 'side',
      component: () => import(/* webpackChunkName: "about" */ './components/side.vue')
    },
    
    
    
    
   

    
    
  ]})
